import React, { useContext } from 'react';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import { AppContext } from '@prisjakt/ui-app-context';
import { Product, CategoryPath } from '../../../../types';
import * as S from '../../styles';

const ProductBreadCrumb: React.FC<IProductBreadCrumbProps> = props => {
  const { product } = props;
  const { t } = useContext(AppContext);
  return (
    <S.BreadCrumbWrapper>
      <Breadcrumb
        homeText={t('common', 'breadcrumb.home')}
        path={
          product.category?.path
            ? (product.category.path.filter(x => x) as CategoryPath[])
            : []
        }
        firstPathSelectable
      />
    </S.BreadCrumbWrapper>
  );
};

interface IProductBreadCrumbProps {
  product: Product;
}

export default ProductBreadCrumb;
